import type {RouteRecordRaw} from "vue-router";

export const routeName = 'Survey';

export const route: RouteRecordRaw = {
    name: routeName,
    // опрос ушедших клиентов, без MainLayout (без шапки и подвала): ссылка вида /survey?uin=… приходит извне, авторизация не нужна
    path: '/survey',
    component: () => import('@/pages/Survey'),
};
